(function () {
  'use strict';

  const ROOT_MARGIN = '1000px';
  let cargando = false;
  let urlSiguiente = null;
  let gridInterior = null;
  let observer = null;
  let sectionIdActual = null;

  function init() {
    gridInterior = document.querySelector('#CollectionLoop');
    if (!gridInterior) return;

    // Detecta el ID de la sección automáticamente — funciona en todas las colecciones
    const sectionContainer = gridInterior.closest('.shopify-section');
    sectionIdActual = sectionContainer ? sectionContainer.id.replace('shopify-section-', '') : null;

    // Busca el link de la página 2
    const linkSiguiente = document.querySelector('.pagination-custom__next, a[href*="page=2"]');
    if (!linkSiguiente || !sectionIdActual) return;

    urlSiguiente = linkSiguiente.href;

    ocultarPaginacionNativa();
    crearSpinner();
    setupObserver();
  }

  async function cargarSiguientePagina() {
    if (cargando || !urlSiguiente) return;

    cargando = true;
    mostrarSpinner();

    try {
      // Construimos la URL con el parámetro sections= para pedir solo los productos
      const urlEstructurada = new URL(urlSiguiente, window.location.origin);
      const paginaActualCargando = urlEstructurada.searchParams.get('page');
      urlEstructurada.searchParams.set('sections', sectionIdActual);

      const respuesta = await fetch(urlEstructurada.toString());
      const json = await respuesta.json();
      const htmlSeccion = json[sectionIdActual];

      if (!htmlSeccion) throw new Error('Fin de contenido');

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlSeccion, 'text/html');
      const nuevosProductosGrid = doc.querySelector('#CollectionLoop');

      if (nuevosProductosGrid && nuevosProductosGrid.innerHTML.trim() !== '') {
        // Inyectamos los productos nuevos al final del grid
        gridInterior.insertAdjacentHTML('beforeend', nuevosProductosGrid.innerHTML);

        // Calculamos cuál es la siguiente página sumando 1
        const siguientePaginaNumero = parseInt(paginaActualCargando) + 1;
        const proximoEnlaceReal = doc.querySelector(`a[href*="page=${siguientePaginaNumero}"]`);

        if (proximoEnlaceReal) {
          urlSiguiente = proximoEnlaceReal.href;
        } else {
          // No hay más páginas → terminamos
          urlSiguiente = null;
        }

        window.dispatchEvent(new Event('resize'));
      } else {
        urlSiguiente = null;
      }

    } catch (error) {
      urlSiguiente = null;
    } finally {
      cargando = false;
      ocultarSpinner();
      if (!urlSiguiente && observer) observer.disconnect();
    }
  }

  function setupObserver() {
    if (observer) observer.disconnect();

    // Elemento invisible al final del grid que dispara la carga
    let sentinel = document.getElementById('infinite-sentinel') || document.createElement('div');
    sentinel.id = 'infinite-sentinel';
    sentinel.style.cssText = 'height:100px; width:100%; clear:both; float:left;';
    gridInterior.after(sentinel);

    observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !cargando && urlSiguiente) {
        cargarSiguientePagina();
      }
    }, { rootMargin: `0px 0px ${ROOT_MARGIN} 0px` });

    observer.observe(sentinel);
  }

  function ocultarPaginacionNativa() {
    // Ocultamos todos los posibles contenedores de paginación del tema
    const elementos = document.querySelectorAll('.pagination-custom, [data-pagination-wrapper], .pagination, .paginate');
    elementos.forEach(el => el.style.setProperty('display', 'none', 'important'));
  }

  function crearSpinner() {
    if (document.getElementById('infinite-scroll-spinner')) return;
    const s = document.createElement('div');
    s.id = 'infinite-scroll-spinner';
    s.style.cssText = 'display:none; justify-content:center; padding:40px; width:100%; clear:both; float:left;';
    s.innerHTML = '<div style="width:30px;height:30px;border:3px solid #eee;border-top:3px solid #000;border-radius:50%;animation:spin 0.8s linear infinite"></div>';
    gridInterior.after(s);
  }

  function mostrarSpinner() {
    const s = document.getElementById('infinite-scroll-spinner');
    if (s) s.style.display = 'flex';
  }

  function ocultarSpinner() {
    const s = document.getElementById('infinite-scroll-spinner');
    if (s) s.style.display = 'none';
  }

  // Animación del spinner
  const style = document.createElement('style');
  style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();